import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/solution/automotive-updated/transform-vehicle.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundPosition: "center top",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={8} lg={7} xl={6} xxl={5}>
            <h2>
              Transform <span>Vehicle</span> Connectivity
            </h2>
            <p>
              Create connected car solutions offering real-time diagnostics,
              navigation, and remote control features.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Build Connected Solutions
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
